import script from "./CollectCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollectCard.vue?vue&type=script&lang=ts&setup=true"

import "./CollectCard.vue?vue&type=style&index=0&id=82f3f86e&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82f3f86e"]])

export default __exports__